var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BuildingPage',{attrs:{"title":"报告审批","description":"审批页预留待我审批、已处理、审批记录等入口，后续根据流程接口补齐。"}})
}
var staticRenderFns = []

export { render, staticRenderFns }